import type { Fee } from 'app/shared/model';
import { getProductsLookup, type ProductLookupRow } from 'app/shared/api/getProductsLookup';

function activeRows(rows: ProductLookupRow[]): ProductLookupRow[] {
  return rows.filter((r) => r.id > 0 && r.active !== false);
}

function toIdNameList(rows: ProductLookupRow[]): { id: number; name: string }[] {
  return activeRows(rows).map((r) => ({ id: r.id, name: r.name }));
}

function toAccAddonShape(
  rows: ProductLookupRow[]
): { id: number; name: string; typeId?: number }[] {
  return activeRows(rows).map((r) => ({
    id: r.id,
    name: r.name,
    ...(r.typeId != null && r.typeId > 0 ? { typeId: r.typeId } : {}),
  }));
}

function toFeeList(rows: ProductLookupRow[]): Fee[] {
  return activeRows(rows).map(
    (r) =>
      ({
        id: r.id,
        name: r.name,
        active: r.active,
        unitTypeId: 0,
        unitTypeName: '',
        lastModifiedDate: null,
        lastUpdatedBy: '',
        entityUpdate: false,
        excludedBookingSystemIds: [],
        hasActiveOffering: undefined,
      }) as Fee
  );
}

export async function loadTaxManagerProductCatalog(): Promise<{
  courses: { id: number; name: string }[];
  accommodations: { id: number; name: string; typeId?: number }[];
  addons: { id: number; name: string; typeId?: number }[];
  transfers: { id: number; name: string }[];
  fees: Fee[];
}> {
  const [courses, accommodations, addons, transfers, fees] = await Promise.all([
    getProductsLookup('Course'),
    getProductsLookup('AccommodationRoom'),
    getProductsLookup('AddOn'),
    getProductsLookup('Transfer'),
    getProductsLookup('Fee'),
  ]);

  return {
    courses: toIdNameList(courses),
    accommodations: toAccAddonShape(accommodations),
    addons: toAccAddonShape(addons),
    transfers: toIdNameList(transfers),
    fees: toFeeList(fees),
  };
}